import { createAction } from "@reduxjs/toolkit";

export const setLocale = createAction("SET_LOCALE@language");

export const fetchMessages = createAction("FETCH_MESSAGES@language");

export const fetchMessagesSuccess = createAction("FETCH_MESSAGES_SUCCESS@language");

export const fetchMessagesFailed = createAction("FETCH_MESSAGES_FAILED@language");
